import { Route, Routes, useParams } from 'react-router-dom'
import InstallationPage from './pages/installation-page'
import InstallationEditPage from './pages/installation-edit'
import { useAppState } from '@/app/hooks/useAppState'
import { useEffect } from 'react'
import NoAccess from '@/features/auth/pages/NoAccess'
import { usePermissions } from '@/shared/hooks/usePermissions'

export default function Installation() {
  const { installationId } = useParams<{ installationId: string }>()
  const { setSelectedInstallationId } = useAppState()
  const { checkPermission } = usePermissions()

  useEffect(() => {
    if (installationId) {
      setSelectedInstallationId(installationId)
    }
  }, [installationId, setSelectedInstallationId])

  const canEditInstallation = checkPermission('installation', 'update')

  return (
    <Routes>
      <Route path="/" element={<InstallationPage />} />
      {canEditInstallation ? (
        <Route path="/edit" element={<InstallationEditPage />} />
      ) : (
        <Route path="/edit" element={<NoAccess />} />
      )}
    </Routes>
  )
}
